import { authenticatedFetch } from '../utils.js';

class WhatsAppService {
  async pair(companyId, phone) {
    const response = await authenticatedFetch('/api/whatsapp/pair', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        company_id: companyId,
        phone: phone
      })
    });
    if (!response.ok) {
      const error = await response.json();
      const customError = new Error(error.detail || 'Failed to pair WhatsApp');
      customError.response = {
        status: response.status,
        data: error
      };
      throw customError;
    }
    return await response.json();
  }

  async getStatus(phone) {
    const response = await authenticatedFetch(`/api/whatsapp/status?phone=${encodeURIComponent(phone)}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!response.ok) {
      const error = await response.json();
      const customError = new Error(error.detail || 'Failed to fetch WhatsApp status');
      customError.status = response.status;
      throw customError;
    }
    return await response.json();
  }

  async disconnect(phone) {
    const response = await authenticatedFetch('/api/whatsapp/disconnect', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone })
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to disconnect WhatsApp');
    }
    return await response.json();
  }

  async completeConnection(phone, connectionCode) {
    const response = await authenticatedFetch('/api/whatsapp/complete-connection', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone,
        connection_code: connectionCode
      })
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to complete connection');
    }
    return await response.json();
  }
}

export default new WhatsAppService();
